import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {getProducts} from "../api/HomeApi";
import Loading from "../../../layouts/Loading";
import {MdOutlineBookmark, MdOutlineLocalOffer, MdOutlinePhoneForwarded} from "react-icons/md";
import {TiChevronLeftOutline} from "react-icons/ti";
import {TbSquareRoundedMinus, TbSquareRoundedPlusFilled} from "react-icons/tb";
import { useCart } from '../../../context/CartContext';
import {showError} from "../../../utils/toastHelper";

const Products = () => {
    const [products, setProducts] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const currencyFormat = Intl.NumberFormat('en-US');

    const { onPlusClick, onMinusClick, getItemCartCount } = useCart();

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const city = window.localStorage.getItem('_ci') || 0
                const params = {
                    count: 4,
                    special: true,
                    list: 1,
                    city,
                }
                const data = await getProducts(params);
                setProducts(data?.data || []);
            } catch (err) {
                 showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);

    if (loading) return <Loading />;

    return (
        <section className="container  mt-5 rtl px-0  ">
            <div className="row mx-1">
                <div className="col-8 home-separator-text ">
محصولات پر طرفدار
                </div>
                <div className="col-4 text-start text-small-3 text-secondary-color mt-1"

                     onClick={() => navigate('/products?special=1')}
                >
                    مشاهده همه
                    <TiChevronLeftOutline className='mx-1'/>
                </div>
            </div>
            <div className="row ms-3 me-2 pb-5 mb-3">
                {
                    products.map((product, index) => {
                        if (product.inventory < 1 && config.shopping_app_settings.show_no_inventory === '0') {
                            return '';
                        }
                        return (

                            <div className="col-6 col-md-3 px-0 mt-0"

                                 key={product.id}
                            >
                                <div className="row vendor-product m-1">
                                    <div className="col-12 text-center mt-3"
                                         onClick={
                                             () => {
                                                 navigate(`/product/${product.id}`)

                                             }
                                         }
                                    >
                                        {
                                            product.vendor_price?.discount_percent > 0 &&
                                            <div className='discount-percent'>
                                                    <span
                                                        className='badge badge-info badge-pill bg-primary-color  text-small-3'>
                                                    {product?.vendor_price?.discount_percent}
                                                        &nbsp;

                                                        %

                                                </span>
                                            </div>
                                        }
                                        {
                                            product.is_favorite > 0 ?
                                                <MdOutlineBookmark className='me-3  text-big-4 text-third-color float-start'

                                                />
                                                :
                                                ''
                                        }
                                        <div className="clearfix"></div>
                                        <img src={product.image} alt={product.name} />

                                    </div>
                                    <div className="col-12 text-center text-small-1 fw-bold" onClick={
                                        () => {
                                            navigate(`/product/${product.id}`)
                                        }
                                    }>
                                        {product.name.substring(0, 70)}
                                    </div>

                                    <div className="col-12 ">
                                        {product.vendor_price?.price ?
                                            <div className=" text-start mt-4 mb-2 text-muted fw-bold text-small-1">

                                                {
                                                    product.vendor_price?.discount_percent > 0 && !product.price_range ?
                                                        <div
                                                            className='text-decoration-line-through fw-normal text-small-3 opacity-50 '>
                                                            {currencyFormat.format(product.vendor_price?.price)}
                                                            &nbsp;
                                                            {config.currency}
                                                        </div> :
                                                        <div
                                                            className=' fw-normal text-small-3 opacity-50'>
                                                            &nbsp;
                                                        </div>

                                                }

                                                <div>
                                                    {

                                                        !product.price_range ?
                                                            <span className='text-small-2'>
                                                                { currencyFormat.format(product.vendor_price?.discounted_price)}
                                                            </span>
                                                            :
                                                        <span className='text-small-2'>{product.price_range}</span>
                                                    }
                                                    &nbsp;
                                                    <span className='text-small-3 text-muted'>
                                                            {config.currency}
                                                    </span>
                                                </div>


                                            </div>
                                            : ''
                                        }
                                    </div>

                                    {
                                        config.shopping_app_settings.show_plus_minus > 0 &&

                                        <div className={
                                            getItemCartCount(product.id) > 0 ? "add-minus-products text-center mt-0 pt-0 bg-custom rounded" : "add-minus-products text-center mt-0 pt-0"
                                        }>

                                            {

                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="add-product-icon text-secondary "
                                                          onClick={() => {
                                                              onMinusClick(product.id, product.minimum_purchase);

                                                          }}>
                                         <TbSquareRoundedMinus/>

                                     </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                getItemCartCount(product.id) > 0 ?
                                                    <span className="px-2" onClick={
                                                        () => {
                                                            /* setShowCountBox(true)
                                                             setCountIndex(index)
                                                             setCountId(product.id)
                                                             setCountPrice(product.price)
                                                             setTheCount(getItemCartCount(product.id))*/
                                                        }
                                                    }>
                                    <input type="tel" className="bg-white" value={getItemCartCount(product.id)}
                                           readOnly/>
                                </span> : <span>&nbsp;</span>
                                            }

                                            {
                                                (product.inventory > 0 || config.shopping_app_settings.ignore_inventory > 0) ?
                                                    <span className="add-product-icon   "
                                                         >
                                                         {product.price > 0 ?
                                                             <span  onClick={() => {
                                                                 onPlusClick(product.id, product.price, product.inventory,product.minimum_purchase, product.maximum_purchase )

                                                             }}><TbSquareRoundedPlusFilled
                                                                 className='text-primary-color'/></span>
                                                             :

                                                             <span className='text-primary text-small-3'
                                                                   onClick={() => navigate('/contact')}
                                                             >

                                                                    <MdOutlinePhoneForwarded className='mx-2'/>
                                                                </span>

                                                         }

                                    </span>
                                                    :
                                                    <span className='text-danger text-small-2'>
                                                            ناموجود
                                                        </span>
                                            }

                                        </div>
                                    }


                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </section>
    );
};

export default Products;